var map = {
	"./TreeView.vue": [
		209,
		1292
	],
	"./activeUser.vue": [
		9481,
		5634,
		6415,
		7064,
		6023,
		701
	],
	"./affiliate.vue": [
		4367,
		5634,
		1413
	],
	"./algostraEsign.vue": [
		5190,
		1378
	],
	"./buy-product.vue": [
		4971,
		5634,
		3914
	],
	"./collateral.vue": [
		2149,
		6878
	],
	"./customerPayinPayout.vue": [
		5938,
		8942
	],
	"./daily-bill.vue": [
		7558,
		2807
	],
	"./digital-contract.vue": [
		6398,
		9076
	],
	"./dormantUser.vue": [
		327,
		5634,
		8065
	],
	"./dpHoldings.vue": [
		4586,
		3656
	],
	"./editDormentAddress.vue": [
		8486,
		6415,
		335
	],
	"./editDormentMobile.vue": [
		6023,
		6023,
		174
	],
	"./editIncomeSlab.vue": [
		2779,
		5634,
		6415,
		2549
	],
	"./esign.vue": [
		8805,
		4258
	],
	"./esignFailed.vue": [
		7300,
		5708
	],
	"./esignMobile.vue": [
		6804,
		411
	],
	"./esignSuccess.vue": [
		7192,
		9548
	],
	"./feedback.vue": [
		6096,
		3728
	],
	"./feedbackConfirmation.vue": [
		8536,
		337
	],
	"./freeSubscription.vue": [
		4926,
		5544
	],
	"./fund-reallocation.vue": [
		6785,
		6283
	],
	"./historyOfPayinPayout.vue": [
		4945,
		5800,
		4693
	],
	"./holdingInsight.vue": [
		375,
		7776,
		8919,
		2010,
		5366
	],
	"./holdings.vue": [
		8490,
		917
	],
	"./incomeCategory.vue": [
		8677,
		6494
	],
	"./journal.vue": [
		3950,
		2713,
		7823
	],
	"./ledger.vue": [
		8252,
		2087
	],
	"./margin-client.vue": [
		1616,
		2551
	],
	"./mutualFundPnL.vue": [
		9138,
		34
	],
	"./mydetails.vue": [
		21,
		5634,
		6415,
		5093,
		909
	],
	"./notebook.vue": [
		2713,
		1467
	],
	"./open-position.vue": [
		2885,
		1062
	],
	"./otsConfirmation.vue": [
		8760,
		561
	],
	"./payConfirmation.vue": [
		2531,
		4935
	],
	"./payIn.vue": [
		7353,
		4046
	],
	"./payOut.vue": [
		3888,
		7825
	],
	"./payOutConfirmation.vue": [
		6745,
		9899
	],
	"./payment-fail-response.vue": [
		3875,
		1265
	],
	"./payment-history.vue": [
		7046,
		4690
	],
	"./payment-success-response.vue": [
		3138,
		7185
	],
	"./pnlCalendar.vue": [
		3198,
		1731
	],
	"./profit&Loss.vue": [
		8148,
		7776,
		4395,
		2105
	],
	"./realized-P&L.vue": [
		5577,
		4812
	],
	"./referral-home.vue": [
		7156,
		5767
	],
	"./request.vue": [
		7165,
		6294
	],
	"./sarathi-score.vue": [
		308,
		8919,
		5694,
		7760
	],
	"./security.vue": [
		4101,
		4941
	],
	"./segment-allocation.vue": [
		6235,
		4877
	],
	"./sso-logout.vue": [
		7768,
		7341
	],
	"./statistics&Networth.vue": [
		9840,
		2491
	],
	"./subscriptions.vue": [
		6311,
		3035
	],
	"./tax-P&L.vue": [
		9275,
		5800,
		5351
	],
	"./trade-register-FNO.vue": [
		9698,
		7894
	],
	"./trade-register.vue": [
		3978,
		9409
	],
	"./treeViewForVerifiedJournal.vue": [
		6867,
		9635
	],
	"./unrealized-P&L.vue": [
		1071,
		3298
	],
	"./verifiedJournal.vue": [
		7688,
		8919,
		5694,
		204
	],
	"./wallet.vue": [
		3082,
		4251
	],
	"./webcamIPV.vue": [
		7064,
		5634,
		7064,
		9653
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5271;
module.exports = webpackAsyncContext;